export const styles = {
  cardActionStyleSmall: {
    zIndex: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  }
}


// WEBPACK FOOTER //
// ./src/categories/styles.js